<template>
  <div class="toast" :class="[type ? `toast--${type}` : '',animate ? 'fadein':'fadeout']">
    <p>{{ content }}</p>
  </div>
</template>
<script>
export default {
  name: "Toast",
  data() {
    return {
      content: "",
      duration: 2000,
      animate: false
    };
  },
  watch: {
    content: {
      handler(newValue) {
        if (newValue) {
          this.animate = true;
        }
      },
      immediate: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.animate = false;
    }, this.duration - 200);
    setTimeout(() => {
      // 2s 后通过父级移除子元素的方式来移除该组件实例和 DOM 节点
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }, this.duration);
  }
};
</script>
<style scoped>
.toast {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  z-index: 9999;
  background: transparent;
}
.toast > p {
  padding: 12px 22px;
  font-size: 18px;
  border-radius: 4px;
  background: rgba(17, 17, 17, 0.7);
  white-space: nowrap;
}
.toast--error p {
  background: #ff5252;
}
.toast--success p {
  background: #4caf50;
}
.fadein {
  animation: animate_in 0.5s;
}
.fadeout {
  animation: animate_out 0.25s;
  opacity: 0;
}
@keyframes animate_in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes animate_out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue